import * as actions from "store/actions/company/create";
import IMei from "Types/IMei";

export interface CompanyCreateState extends IMei {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: CompanyCreateState = {
    loading: false,
    errors: {},
    businessName: "",
    socialName: "",
    cnpj: "",
    code: ""
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_COMPANY: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_COMPANY_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_COMPANY_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
